import { InjectionToken } from '@angular/core';

/** API surface exposed by `lib-anc-radio-group` to child `lib-anc-radio` components. */
export interface AncRadioGroupHost {
    value(): string | number | boolean | null;
    disabled(): boolean;
    resolvedName(): string;
    select(optionValue: string | number | boolean): void;
}

/** Injection token for child `lib-anc-radio` components to access their parent group. */
export const ANC_RADIO_GROUP = new InjectionToken<AncRadioGroupHost>('ANC_RADIO_GROUP');
